<template>
  <div class="actor_message_form">
    <ValidationObserver ref="form">
      <form
        action=""
        method="post"
        class="form"
      >
        <ValidationProvider name="メッセージ" rules="required|max:1000" v-slot="{ errors }">
          <textarea name="text" v-model="form.text" placeholder="こちらをタッチしてメッセージを入力してください" rows="8"></textarea>
          <div class="text_left base_text_style actor_message_text">※1000文字以内<br>※絵文字はご利用できません</div>
          <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
        </ValidationProvider>
        <p v-if="form.errors.length > 0" class="form_error">
          <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
        </p>
        <p>
          <button
            type="submit"
            class="btn arrow"
            :disabled="isSend"
            @click.prevent="checkForm"
          >確認画面へ</button>
        </p>
        <p>
          <a href="#" class="arrow link_main--text" @click.prevent="$router.go(-1)">{{ prevLinkLabel }}</a>
        </p>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import {
  required,
  max
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を入力してください'
})

extend('max', {
  ...max,
  message: '{_field_}は{length}文字以内で入力してください'
})

export default {
  name: 'ActorMessageForm',
  props: {
    form: Object
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      isSend: false,
      prevComponent: ''
    }
  },
  computed: {
    prevLinkLabel () {
      let label = '鑑定師一覧に戻る'
      if (this.prevComponent === 'MailDetail') {
        label = '鑑定結果詳細に戻る'
      } else if (this.prevComponent === 'ActorDetail') {
        label = '鑑定師詳細に戻る'
      }
      return label
    }
  },
  methods: {
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.$refs.form.validate().then(success => {
        if (success) {
          this.$router.pushIsses({ name: 'ActorMessageConfirm' })
        } else {
          this.isSend = false
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevComponent = from.name
    })
  }
}
</script>
